<template>
  <div>
    <v-dialog v-model="dialog" max-width="450px">
      <v-card
        :loading="loading"
        class="mx-auto elevation-1"
        width="450px">

        <v-img 
          class="text-white d-flex align-start"
          :src="require('@/assets/praia_ondas.jpg')"
          height="200"
          cover>
          <v-card-title class="d-flex justify-end w-100">
            <img style="height: 50px;" :src="require('@/assets/logo.png')" alt="smartsurf_logo" />
          </v-card-title>
        </v-img>

        <v-card-title v-if="!registered">Register</v-card-title>

        <v-card-text v-if="!registered">
          <v-form>
            <v-text-field
              v-model="newUser.email"
              label="Email"
              name="nm-smart-email-new"
              prepend-inner-icon="mdi-account"
              type="text"
              autocomplete="off"
              variant="outlined"
            ></v-text-field>
            <v-text-field
              v-model="newUser.password"
              id="password"
              label="Password"
              name="nm-smart-password-new"
              prepend-inner-icon="mdi-lock"
              type="password"
              autocomplete="new-password"
              variant="outlined"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions v-if="!registered" class="pa-4">
          <v-btn 
            variant="outlined" 
            @click="dialog = false"
            prepend-icon="mdi-close"
          >
            {{ $t("messages.close") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn 
            color="primary" 
            variant="elevated"
            @click="signup()" 
            :disabled="!newUser.email || !newUser.password"
            prepend-icon="mdi-account-plus"
          >
            Register
          </v-btn>
        </v-card-actions>

        <v-card-title v-if="registered">Account Activation</v-card-title>

        <v-card-text v-if="registered">
            <v-alert
              icon="mdi-shield-lock-outline"
              prominent
              variant="text"
              type="info"
              class="blinking-element"
            >
            Thank you for registering! We've sent a confirmation email to the address you provided.<br/><br/>
            Please check your <b>inbox</b> <i>(and your spam folder, just in case)</i> and click on the activation link to complete your registration.
            </v-alert>
        </v-card-text>

        <v-card-actions v-if="registered" class="pa-4">
          <v-spacer></v-spacer>
          <v-btn 
            variant="outlined" 
            @click="dialog = false"
            prepend-icon="mdi-close"
          >
            {{ $t("messages.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import httpClient from '../../api/httpClient'

export default {
  inject: ['bus'],
  data () {
    return {
      dialog: false,
      loading: false,
      registered: false,
      newUser: {},
    }
  },
  mounted () {
    this.bus.on("signupDialog", () => this.dialog = true)
  },
  methods: {
    signup() {
      this.loading = true
      httpClient
        .post('/oauth/api/v1/register', this.newUser)
        .then(r => {
          this.loading = false
          if (!r.data.error) {
            this.registered = true
          }
          this.bus.emit('modernSnackBarMsg', {error: r.data.error, msg: r.data.error ? this.$t('messages.error_registering') : r.data.message})
        })
        .catch(e => {
          this.loading = false
          console.error(e.message)
          this.bus.emit('modernSnackBarMsg', {error: true, msg: "Please contact the support"})
        })
    }
  }
}
</script>

<style scoped>
@keyframes blink {
  50% { opacity: 1; }
  70% { opacity: 0.8; }
  100% { opacity: 1; }
}

.blinking-element {
  animation: blink 2s infinite;
}
</style>